import { settings } from '../../../settings/settings-util'

export default class UiVersionNumberRequestProcessor
{
    constructor(passedSettings)
    {
        this._settings = passedSettings || settings;
    }

    static getDefaultSettings()
    {
        return settings;
    }

    initialize(store)
    {
        this._store = store;
    }

    getRequestProcessor()
    {
        return this;
    }

    process(input)
    {
        let inputParameters = {};
        if (input.parameters)
        {
            inputParameters = input.parameters;
        }

        let versionParamName = this._settings.uiVersionNumberParam ? this._settings.uiVersionNumberParam : "UiVersionNumber";

        inputParameters[versionParamName] = this._settings.version;

        return Object.assign({}, input, { parameters: inputParameters });
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/request-processor-ui-version-number/src/request-processor-ui-version-number.js